import React from 'react';
import { Result, Button } from 'antd';
import { reportError } from '../utils/reportError';
import i18n from '../i18n';

// 页面内容区的错误边界：某个组件渲染抛错时只替换内容区，页头 / 页脚仍在、可点去别的页。
// 没有它时任何一处渲染异常都会卸载整个应用 → 整站白屏（2026-10-17 首页热门路线 .toFixed 即如此）。
// 在 App 里以 pathname 作 key 挂载：换页即重置。
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('页面渲染出错:', error, info?.componentStack);
    reportError('render', error, { componentStack: info?.componentStack });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Result
        status="error"
        title={i18n.t('common:errorPage.title')}
        subTitle={i18n.t('common:errorPage.subTitle')}
        extra={<Button type="primary" onClick={() => window.location.reload()}>{i18n.t('common:errorPage.reload')}</Button>}
      />
    );
  }
}

export default ErrorBoundary;
